import { Component, effect, input, output, ChangeDetectionStrategy } from '@angular/core';
import { ValidatorFn, Validators, AsyncValidatorFn } from '@angular/forms';
import { Observable } from 'rxjs';

import { InputComponent } from '../input/input.component';
import { AsyncValidator } from '../validator/async-validator';

@Component({
    selector: 'app-graphql-checker',
    templateUrl: './graphql-checker.component.html',
    styleUrls: ['./graphql-checker.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GraphQLCheckerComponent extends InputComponent {
    readonly validate = input.required<(value: unknown) => Observable<boolean>>();
    readonly parentModel = input<unknown>();

    readonly clear = output<void>();

    constructor() {
        super();

        effect(() => {
            const model = this.model();
            if (model?.length) {
                this.formControl()?.setValue(model);
            }
        });
    }

    protected override getValidators(): ValidatorFn[] {
        const validators = super.getValidators();
        const pattern = this.meta()?.pattern;

        if (pattern) {
            validators.push(Validators.pattern(pattern));
        }

        return validators;
    }

    protected override getAsyncValidators(): AsyncValidatorFn[] {
        const validators = super.getAsyncValidators();

        validators.push(
            AsyncValidator(value => this.validate()(value))
        );

        return validators;
    }

    public onClear(): void {
        this.formControl()?.setValue('');
        this.clear.emit();
    }
}
